const fontSizes = {
  xs: '8px',
  s: '12px',
  '2s': '14px',
  m: '16px',
  '2m': '18px',
  sm: '20px',
  l: '24px',
  lg: '30px',
  xl: '32px',
  '2.5xl': '36px',
  '3.5xl': '40px',
  '2xl': '48px',
  size_50: '50px',
  '3xl': '64px',
};

const fontWeight = {
  thin: 100,
  extraLight: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extraBold: 800,
  black: 900,
};

const fontFamily = {
  onest: '"Onest", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  inter: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  interTight: '"Inter Tight", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  golosText: '"Golos Text", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
};

const lineHeight = {
  none: '1',
  tight: '1.25',
  snug: '1.375',
  normal: '1.5',
  relaxed: '1.625',
  loose: '2',
  // Specific line heights
  body: '1.6',
  heading: '1.2',
};

const letterSpacing = {
  tighter: '-0.05em',
  tight: '-0.025em',
  normal: '0',
  wide: '0.025em',
  wider: '0.05em',
  widest: '0.1em',
};

// Text styles (комбинация размера, веса, line-height)
const textStyles = {
  // Headings
  h1: {
    fontSize: fontSizes['3xl'],
    fontWeight: fontWeight.bold,
    lineHeight: lineHeight.heading,
    letterSpacing: letterSpacing.tight,
  },
  h2: {
    fontSize: fontSizes['2xl'],
    fontWeight: fontWeight.bold,
    lineHeight: lineHeight.heading,
    letterSpacing: letterSpacing.tight,
  },
  h3: {
    fontSize: fontSizes.xl,
    fontWeight: fontWeight.semibold,
    lineHeight: lineHeight.heading,
    letterSpacing: letterSpacing.normal,
  },
  h4: {
    fontSize: fontSizes.l,
    fontWeight: fontWeight.semibold,
    lineHeight: lineHeight.heading,
    letterSpacing: letterSpacing.normal,
  },
  h5: {
    fontSize: fontSizes.sm,
    fontWeight: fontWeight.semibold,
    lineHeight: lineHeight.snug,
    letterSpacing: letterSpacing.normal,
  },
  h6: {
    fontSize: fontSizes.m,
    fontWeight: fontWeight.semibold,
    lineHeight: lineHeight.snug,
    letterSpacing: letterSpacing.normal,
  },

  // Body text
  body: {
    fontSize: fontSizes.m,
    fontWeight: fontWeight.normal,
    lineHeight: lineHeight.body,
    letterSpacing: letterSpacing.normal,
  },
  bodySmall: {
    fontSize: fontSizes['2s'],
    fontWeight: fontWeight.normal,
    lineHeight: lineHeight.body,
    letterSpacing: letterSpacing.normal,
  },
  bodyLarge: {
    fontSize: fontSizes['2m'],
    fontWeight: fontWeight.normal,
    lineHeight: lineHeight.body,
    letterSpacing: letterSpacing.normal,
  },

  // Captions
  caption: {
    fontSize: fontSizes.s,
    fontWeight: fontWeight.normal,
    lineHeight: lineHeight.normal,
    letterSpacing: letterSpacing.normal,
  },
  overline: {
    fontSize: fontSizes.s,
    fontWeight: fontWeight.semibold,
    lineHeight: lineHeight.normal,
    letterSpacing: letterSpacing.wider,
    textTransform: 'uppercase' as const,
  },
};

export const typography = {
  ...fontSizes,
  ...fontWeight,
  ...fontFamily,
  lineHeight,
  letterSpacing,
  textStyles,
};
